module.exports = __webpack_public_path__ + "f3a2928403e70546787691b79615b546.MP3";